/** Configuração global do Caminho em APP_CONFIG/CAMINHO. */

import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import tipo from './motor/tipo';

export const CAMINHO_CONFIG_PATH = ['APP_CONFIG', 'CAMINHO'];
export const { TIPOS_CAMINHO, TIPO_CAMINHO_PADRAO } = tipo;

let cache = null;
let emVoo = null;

export function tipoCaminhoEmCache() {
  return cache;
}

export async function carregarTipoCaminho({ forcar = false } = {}) {
  if (!forcar && cache) return cache;
  if (!forcar && emVoo) return emVoo;

  emVoo = (async () => {
    try {
      const snap = await getDoc(doc(db, ...CAMINHO_CONFIG_PATH));
      cache = tipo.tipoDoDocumento(snap.exists() ? snap.data() : null);
    } catch (erro) {
      console.warn('[caminho] config remota indisponível; usando padrão:', erro?.message);
      cache = TIPO_CAMINHO_PADRAO;
    } finally {
      emVoo = null;
    }
    return cache;
  })();
  return emVoo;
}

export function invalidarTipoCaminho() {
  cache = null;
  emVoo = null;
}

export default carregarTipoCaminho;
